import { getStyles as getAutocompleteStyles } from 'app/components/Core/ChakraAutocomplete/styles';
import { GroupBase, ChakraStylesConfig } from 'chakra-react-select';
import { SelectOption } from './types';

export const getStyles = (
  customStyles?: ChakraStylesConfig<
    SelectOption,
    false,
    GroupBase<SelectOption>
  >
): ChakraStylesConfig<SelectOption, false, GroupBase<SelectOption>> => {
  const autocompleteStyles = getAutocompleteStyles<SelectOption>({
    customStyles: customStyles || {},
    customComponents: {},
  });

  return {
    ...autocompleteStyles,
    clearIndicator: (props) => ({
      ...props,
      width: 'unset',
      margin: 'unset',
      padding: 0,
      paddingLeft: 2,
      _hover: {
        background: 'transparent',
      },
    }),
    singleValue: (props) => ({
      ...props,
      position: 'relative',
      top: 0,
      left: 0,
      width: '100%',
      transform: 'none',
      marginLeft: 0,
    }),
  };
};
